/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Scan_BroccoliInputs */

const en_portal_scan_broccoli = /** @type {(inputs: Portal_Scan_BroccoliInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Broccoli 120 g`)
};

const pl_portal_scan_broccoli = /** @type {(inputs: Portal_Scan_BroccoliInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brokuł 120 g`)
};

/**
* | output |
* | --- |
* | "Broccoli 120 g" |
*
* @param {Portal_Scan_BroccoliInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_scan_broccoli = /** @type {((inputs?: Portal_Scan_BroccoliInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Scan_BroccoliInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_scan_broccoli(inputs)
	return en_portal_scan_broccoli(inputs)
});